export default __webpack_public_path__ + "static/sm-poster5-990bd0aabd0547326f8b5b51faa336c6.png";